import { render, staticRenderFns } from "./modalCommon.vue?vue&type=template&id=d80f0b0a&scoped=true"
import script from "./modalCommon.vue?vue&type=script&lang=js"
export * from "./modalCommon.vue?vue&type=script&lang=js"
import style0 from "./modalCommon.vue?vue&type=style&index=0&id=d80f0b0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80f0b0a",
  null
  
)

export default component.exports